import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    ExternalMeetingRecordingDelete as ExternalMeetingRecordingDeleteMutation,
    ExternalMeetingRecordingDeleteVariables as ExternalMeetingRecordingDeleteVariables,
    ExternalMeetingRecordingDeleteInput,
} from 'nutshell-graphql-types';

import EXTERNAL_MEETING_RECORDING_DELETE from '../mutations/external-meeting-recording-delete.graphql';

export const useExternalMeetingRecordingDelete = (): {
    externalMeetingRecordingDelete: (arg1: ExternalMeetingRecordingDeleteInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [externalMeetingRecordingDelete, {loading, error}] = useMutation<
        ExternalMeetingRecordingDeleteMutation,
        ExternalMeetingRecordingDeleteVariables
    >(EXTERNAL_MEETING_RECORDING_DELETE);

    return {
        externalMeetingRecordingDelete: (input: ExternalMeetingRecordingDeleteInput) =>
            externalMeetingRecordingDelete({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
